import { NAMESPACE } from 'react/api/actions/base';

const actions = {
  toggleSuspenseActions: `${NAMESPACE}_FOOTER_TOGGLE_USER_WINDOW`,
  toggleMiniDashboard: `${NAMESPACE}_FOOTER_TOGGLE_MINI_DASHBOARD`,
}

const actionCreators = {
  toggleSuspenseActions: payload => ({ type: actions.toggleSuspenseActions, payload }),
  toggleMiniDashboard: payload => ({ type: actions.toggleMiniDashboard, payload }),
}

export default {
  actions,
  actionCreators
};
